import * as types from './actionTypes'

const initialState = {
    data: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.RELATIONS_FETCH_SUCCESS:
            return {
                ...state,
                data: action.data
            }

        case types.RELATIONS_FETCH_FAILED:
            return {
                ...state
            }

        case types.RELATION_UPDATE_SUCCESS: {
        const data = [...state.data]
        const index = data.findIndex(item => item.id === action.relation.id)
        index === -1 ? data.splice(data.length, 0, action.relation) : data.splice(index, 1, action.relation)

            return {
                ...state,
                data: [
                    ...data
                ]
            }
        }

        case types.RELATION_UPDATE_FAILED:
            return {
                ...state
            }

        default:
            return state
    }
}
